export class Job
{
	jobId: number;
	jobDate: Date;
}
